import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
const FormError = React.forwardRef(({ className, ...props }, ref) => {
    return (_jsx("p", { ref: ref, className: cn('text-sm text-red-600', className), ...props }));
});
FormError.displayName = 'FormError';
export { FormError };
